module.exports = __webpack_public_path__ + "static/media/0.beginning.9463bf92.mp4";